import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Box
} from "@mui/material";

const EditSocioModal = ({ open, onClose, socio, onSave }) => {
  const [formData, setFormData] = React.useState(socio || {});
  const [loading, setLoading] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    setFormData(socio || {});
  }, [socio]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await onSave(formData);
      setSuccessMessage("Datos guardados correctamente.");
      onClose();
    } catch (error) {
      console.error(error);
      setErrorMessage("Hubo un error al guardar.");
    } finally {
      setLoading(false);
    }
  };

  if (!socio) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Editar Socio</DialogTitle>
      <DialogContent>
        <Typography variant="h6" mt={2}>Datos Personales del Socio</Typography>
        <Box mt={2}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                name="NOMBRE_APELLIDO"
                label="Nombre y Apellido"
                fullWidth
                value={formData.NOMBRE_APELLIDO || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="PAIS"
                label="País"
                fullWidth
                value={formData.PAIS || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="IDENTIFICACION"
                label="Identificación"
                fullWidth
                value={formData.IDENTIFICACION || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="LUGAR_FECHA_NACIMIENTO"
                label="Lugar y Fecha de Nacimiento"
                fullWidth
                value={formData.LUGAR_FECHA_NACIMIENTO || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="TELEFONOS"
                label="Teléfonos"
                fullWidth
                value={formData.TELEFONOS || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="EMAIL"
                label="Email"
                fullWidth
                value={formData.EMAIL || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                select
                name="GENERO"
                label="Género"
                fullWidth
                value={formData.GENERO || ""}
                onChange={handleChange}
                SelectProps={{ native: true }}
              >
                <option value="">Seleccione...</option>
                <option value="Hombre">Hombre</option>
                <option value="Mujer">Mujer</option>
                <option value="No Binario">No Binario</option>
              </TextField>
            </Grid>
            <Grid item>
              <TextField
                select
                name="TIPO_SOCIO"
                label="Tipo de Socio"
                fullWidth
                value={formData.TIPO_SOCIO || ""}
                onChange={handleChange}
                SelectProps={{ native: true }}
              >
                <option value="">Seleccione...</option>
                <option value="ACTIVO">ACTIVO</option>
                <option value="ADHERENTE">ADHERENTE</option>
              </TextField>
            </Grid>
            <Grid item>
              <TextField
                name="FECHA_MEMBRESIA"
                label="Fecha Membresía"
                fullWidth
                value={formData.FECHA_MEMBRESIA || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Box>
        <Typography variant="h6" mt={4}>Datos Profesionales y Laborales</Typography>
        <Box mt={2}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                name="CARGO"
                label="Cargo"
                fullWidth
                value={formData.CARGO || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="CARGOS_DESEMPENADOS_GCIAMT"
                label="Cargos Desempeñados GCIAMT"
                fullWidth
                value={formData.CARGOS_DESEMPENADOS_GCIAMT || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="FORMACION_PROFESIONAL"
                label="Formación Profesional"
                fullWidth
                value={formData.FORMACION_PROFESIONAL || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="DIRECCION_LABORAL"
                label="Dirección Laboral"
                fullWidth
                value={formData.DIRECCION_LABORAL || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="INSTITUCION_LABORAL"
                label="Institución Laboral"
                fullWidth
                value={formData.INSTITUCION_LABORAL || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="MIEMBRO_OTRAS_SOCIEDADES"
                label="Miembro de Otras Sociedades"
                fullWidth
                value={formData.MIEMBRO_OTRAS_SOCIEDADES || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="ID"
                label="ID"
                fullWidth
                value={formData.ID || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                name="ID_SOCIO"
                label="ID Socio"
                fullWidth
                value={formData.ID_SOCIO || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <Box display="flex" justifyContent="center" mt={4}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Actualizar
        </Button>
      </Box>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
      {loading && (
        <Box mt={2} textAlign="center">
          <Typography variant="body2">Guardando...</Typography>
        </Box>
      )}
      {successMessage && (
        <Dialog open onClose={() => setSuccessMessage("")}>
          <DialogTitle>Éxito</DialogTitle>
          <DialogContent>
            <Typography>{successMessage}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSuccessMessage("")}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}
      {errorMessage && (
        <Dialog open onClose={() => setErrorMessage("")}>
          <DialogTitle>Error</DialogTitle>
          <DialogContent>
            <Typography>{errorMessage}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setErrorMessage("")}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}
    </Dialog>
  );
};

export default EditSocioModal;